import { showModal } from 'shared/components/other';
import { ErrorInterceptor } from '../../types';

export const retryRequest: ErrorInterceptor = ({ instance, config, error }) =>
  new Promise((resolve) => {
    showModal((isAccessRetry: boolean) => {
      resolve(isAccessRetry ? instance(config) : { data: null, error });
    });
  });
